import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-loading',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loading.component.html'
})
export class LoadingComponent {
  /**
   * 保留舊呼叫介面；所有頁面現在共用同一套 Tailwind Loading 外觀。
   */
  @Input() style: 'tailwind' | 'bootstrap' = 'bootstrap';
  
  /**
   * Loading文字訊息
   */
  @Input() message: string = '載入中...';
  
  /**
   * 字體大小（px）
   */
  @Input() fontSize: number = 16;
  
  /**
   * 背景類型
   * 'overlay' - 不透明全螢幕覆蓋層（適用於 modal 或整頁 loading）
   * 'solid-overlay' - 保留舊呼叫介面，外觀與 overlay 一致
   * 'container' - 不透明色底的容器內 loading（適用於區塊 loading）
   */
  @Input() background: 'overlay' | 'solid-overlay' | 'container' = 'container';
  
}
